export default __webpack_public_path__ + "static/media/raqqa.4c34566d.jpg";